import styles from "./Pill.module.css";

export default function Pill(props) {
  return <span className={styles.pill} {...props?.rest}>{props?.children}</span>
};
